module.exports = __webpack_public_path__ + "static/img/honor-3.d1ee353.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-3.png
// module id = V7T6
// module chunks = 0